// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as PopupMod from "../../types/PopupMod.bs.js";
import * as MarkerMod from "../../types/MarkerMod.bs.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as LabelComponent from "../../../views/LabelComponent.bs.js";
import * as OverlayViewMod from "../../types/OverlayViewMod.bs.js";
import * as PopupComponentMod from "../../views/PopupComponentMod.bs.js";
import * as MarkerComponentMod from "../../views/MarkerComponentMod.bs.js";
import * as OverlayComponentMod from "../../views/OverlayComponentMod.bs.js";

function getInfoWindowPopup(onCloseClick, showPopup, content, positionOpt, popupAnchorOpt, param) {
  var position = positionOpt !== undefined ? Caml_option.valFromOption(positionOpt) : undefined;
  var popupAnchor = popupAnchorOpt !== undefined ? Caml_option.valFromOption(popupAnchorOpt) : undefined;
  if (showPopup) {
    return React.createElement(PopupComponentMod.make, {
                config: PopupMod.make_props(Caml_option.some(position), undefined, Caml_option.some(popupAnchor), onCloseClick, undefined, undefined),
                children: React.createElement(LabelComponent.make, {
                      tooltipInfo: content
                    })
              });
  } else {
    return null;
  }
}

function GoogleMarkerComponent(Props) {
  var markerData = Props.markerData;
  var basePosition = Props.basePosition;
  var markerAnchor = Props.markerAnchor;
  var zIndexOpt = Props.zIndex;
  var uid = Props.uid;
  var showPopup = Props.showPopup;
  var togglePopupVisibility = Props.togglePopupVisibility;
  var zIndex = zIndexOpt !== undefined ? zIndexOpt : 1000;
  var match = React.useState(function () {
        return false;
      });
  var setClicked = match[1];
  var clicked = match[0];
  React.useEffect((function () {
          if (!showPopup) {
            Curry._1(setClicked, (function (param) {
                    return false;
                  }));
          }
          
        }), [showPopup]);
  var onClickHandler = function (_e) {
    Curry._1(setClicked, (function (param) {
            return true;
          }));
    if (!showPopup) {
      return Curry._1(togglePopupVisibility, uid);
    }
    
  };
  var onMouseOverHandler = function (_e) {
    if (!showPopup) {
      return Curry._1(togglePopupVisibility, uid);
    }
    
  };
  var onMouseOutHandler = function (_e) {
    !clicked;
    
  };
  var onCloseClickHandler = function (param) {
    return Curry._1(togglePopupVisibility, uid);
  };
  var icon = markerData.icon_data;
  if (icon.TAG === /* Img */0) {
    return React.createElement(MarkerComponentMod.make, {
                config: MarkerMod.make_props(basePosition, true, undefined, Caml_option.some(zIndex), Caml_option.some(icon._0), Caml_option.some(markerAnchor.iconAnchor), undefined, onMouseOverHandler, onMouseOutHandler, onClickHandler, undefined, undefined, undefined),
                children: getInfoWindowPopup(onCloseClickHandler, showPopup, markerData.tooltip, Caml_option.some(basePosition), Caml_option.some(markerAnchor.popupAnchor), undefined),
                key: "marker-" + String(uid)
              });
  } else {
    return React.createElement(React.Fragment, undefined, React.createElement(OverlayComponentMod.make, {
                    config: OverlayViewMod.make_props(basePosition, undefined, Caml_option.some(onMouseOverHandler), Caml_option.some(onMouseOutHandler), Caml_option.some(onClickHandler), icon._0, undefined, undefined),
                    key: "waypoint" + String(uid)
                  }), getInfoWindowPopup(onCloseClickHandler, showPopup, markerData.tooltip, Caml_option.some(basePosition), Caml_option.some([
                        0,
                        -40
                      ]), undefined));
  }
}

var make = GoogleMarkerComponent;

export {
  getInfoWindowPopup ,
  make ,
  
}
/* react Not a pure module */
